import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigService } from 'src/app/core/services/config.service';
import { CostEstimation } from 'src/app/feature-module/cost-estimations/models/CostEstimation';
import { CostEstimationSearchResultItem } from '../models/CostEstimationSearchResultItem';
import { SearchCostEstimationsCriteria } from '../models/SearchCostEstimationsCriteria';
import { ClaimMarkersForCostEstimation } from '../models/ClaimMarkersForCostEstimation';



@Injectable({
  providedIn: 'root'
})
export class CostEstimationService {

  constructor(private http: HttpClient,
    private configService: ConfigService) {

  }

  public storeCostEstimation(data: CostEstimation): Observable<number> {
    return this.http.post<number>(
      this.configService.PortalWebApiUrl + 'CostEstimation', data);
  }

  public getCostEstimation(id: number): Observable<CostEstimation> {
    return this.http.get<CostEstimation>(
      this.configService.PortalWebApiUrl + 'CostEstimation/' + id);
  }

  public getClaimMarkersForCostEstimation(claimidentifier: string): Observable<ClaimMarkersForCostEstimation> {
    return this.http.get<ClaimMarkersForCostEstimation>(
      this.configService.PortalWebApiUrl + 'CostEstimation/markers/' + claimidentifier);
  }

  public searchCostEstimations(criteria: SearchCostEstimationsCriteria): Observable<CostEstimationSearchResultItem[]> {
    return this.http.post<CostEstimationSearchResultItem[]>(
      this.configService.PortalWebApiUrl + 'CostEstimation/search', criteria);
  }
}
